import { createGenericFetchMachine } from '@/common/overmind/machines/generic-fetch-machine';
import type { FeaturesInLayer } from '@/overmind/effects/adapters/baseadapter';

import * as actions from './actions';

const state = createGenericFetchMachine<FeaturesInLayer[]>();

export type FeatureGeometriesMachine = typeof state;

export { state, actions };
